// eslint-disable-next-line import/prefer-default-export
export const bannerTypeMap = {
  direct: 'primary',
  page: 'dark',
}
